'use client';
import Link from 'next/link';
import { ArrowLeft } from 'lucide-react';

export default function AboutPage() {
  return (
    <div className="min-h-screen bg-white text-[#0f172a]">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 py-16">
        <Link href="/" className="inline-flex items-center gap-2 text-sm text-slate-500 hover:text-[#1a56ff] mb-8 transition-colors">
          <ArrowLeft size={16} /> Back to Home
        </Link>
        <h1 className="text-3xl sm:text-4xl font-bold mb-6">About dropservice.in</h1>
        <div className="prose prose-slate max-w-none text-slate-600 space-y-5 text-sm leading-relaxed">
          <p>dropservice.in is India&apos;s trusted drop-service platform built for aspiring entrepreneurs who want to run a professional service business without any technical skills.</p>
          <p>We connect authorized agents with expert service delivery teams. Agents sell Website Development, Press Release, and Business Compliance services to local businesses — our backend team handles all the work and delivers within 24 hours.</p>
          <p>Founded with the mission to democratize entrepreneurship across India, dropservice.in has helped over 2,400 agents earn commissions and build sustainable income streams.</p>
          <p>dropservice.in is a product of <strong>Kanglei Sannathong Pvt. Limited</strong>, a registered company in India.</p>
        </div>
      </div>
    </div>
  );
}
